import { useDispatch } from "react-redux";
import { removeUser } from "@Redux/userSlice";
import { useNavigate } from "react-router-dom";
import { USER_LOGOUT } from "../API/APIRoutes";
import axios from "@API/axios";
import { setSnackbar } from "@Redux/snackBarSlice";

const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = async () => {
    // Stop any ongoing speech synthesis
    window.speechSynthesis.cancel();

    localStorage.clear();
    sessionStorage.clear();

    dispatch(removeUser());

    dispatch(
      setSnackbar({
        open: true,
        message: "You have been logged out.",
        error: false,
      })
    );
    navigate("/");
    try {
      await axios.get(USER_LOGOUT);
    } catch (err) {
      console.error("Logout API failed", err);
    }
  };

  return logout;
};

export default useLogout;
